import * as go from 'gojs';
import { getImageStorageWith1Output } from 'unitData/Storage/StorageData';
import {
  CONVERSIONS,
  convertToCurrentMetric,
  getMetricUnit,
} from 'util/conversions';
import { getImageBinding, getIOPort, makeNode } from '../../utils';
import theme from 'theme/theme';
import type { StorageOneOutputNodeData } from 'gojs/types';

const $ = go.GraphObject.make;

const StorageWith1OutputTemplate = makeNode(
  getImageBinding('storageWith1OutputImg', getImageStorageWith1Output),
  [
    getIOPort(go.Spot.Right, 'output'),
    getIOPort(go.Spot.Top, 'input'),
    $(
      go.Panel,
      'Auto',
      { alignment: new go.Spot(0.5, 1, 0, 8) },
      new go.Binding('visible', '', (data: StorageOneOutputNodeData) => {
        const { outputFlow, massFlows } = data;
        if (!massFlows) {
          return false;
        }
        return outputFlow &&
          outputFlow?.totalMass >= 0 &&
          data.retainedAmount !== undefined
          ? true
          : false;
      }),
      $(go.Shape, 'RoundedRectangle', {
        strokeWidth: 0,
        fill: theme.palette.info.main,
        alignment: go.Spot.Bottom,
      }),
      $(
        go.TextBlock,
        {
          stroke: '#fff',
          alignment: go.Spot.Bottom,
          margin: new go.Margin(0, 2, 0, 2),
        },
        new go.Binding('text', '', (data: StorageOneOutputNodeData) => {
          if (data.showProductPercentage) {
            return `${convertToCurrentMetric({
              value: data.retainedAmount,
              metricType: data.metricType,
              conversionType: CONVERSIONS.CAPACITY,
              decimals: 0,
            })} ${getMetricUnit(data.metricType, CONVERSIONS.CAPACITY)}${
              Number.isFinite(data.productPercentage)
                ? `, ${data.productPercentage}%`
                : ''
            }`;
          }
          return `${convertToCurrentMetric({
            value: data.retainedAmount,
            metricType: data.metricType,
            conversionType: CONVERSIONS.CAPACITY,
            decimals: 0,
          })} ${getMetricUnit(data.metricType, CONVERSIONS.CAPACITY)}`;
        }),
        new go.Binding('font', '', (data: StorageOneOutputNodeData) => {
          return `normal normal 500 ${data.canvasBodyFontSize.size}px Sandvik Sans Text`;
        }),
      ),
    ),
  ],
);

export default StorageWith1OutputTemplate;
